import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Ecunel Fitness Gym - Το Καλύτερο Blog για Fitness</title>
        <meta name="description" content="Ecunel Fitness Gym - Το καλύτερο blog για fitness, προπονήσεις και υγιεινή ζωή στην Ελλάδα" />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Πολιτική Απορρήτου</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Εισαγωγή</h2>
          <p>
            Καλώς ήρθατε στο Ecunel Fitness Gym. Σεβόμαστε την ιδιωτικότητά σας και δεσμευόμαστε 
            να προστατεύσουμε τα προσωπικά σας δεδομένα. Αυτή η πολιτική απορρήτου θα σας ενημερώσει 
            για το πώς φροντίζουμε τα προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας και 
            θα σας ενημερώσει για τα δικαιώματα απορρήτου σας και πώς σας προστατεύει ο νόμος.
          </p>
        </section>

        <section>
          <h2>2. Δεδομένα που Συλλέγουμε</h2>
          <p>Μπορούμε να συλλέξουμε, να χρησιμοποιήσουμε, να αποθηκεύσουμε και να μεταφέρουμε διαφορετικά είδη προσωπικών δεδομένων σχετικά με εσάς, τα οποία έχουμε ομαδοποιήσει ως εξής:</p>
          <ul>
            <li><strong>Δεδομένα Ταυτότητας:</strong> όνομα, επώνυμο, όνομα χρήστη ή παρόμοιο αναγνωριστικό.</li>
            <li><strong>Δεδομένα Επικοινωνίας:</strong> διεύθυνση email, αριθμοί τηλεφώνου.</li>
            <li><strong>Τεχνικά Δεδομένα:</strong> διεύθυνση IP, δεδομένα σύνδεσης, τύπος και έκδοση προγράμματος περιήγησης, ρύθμιση ζώνης ώρας και τοποθεσία, τύποι και εκδόσεις προσθέτων προγράμματος περιήγησης, λειτουργικό σύστημα και πλατφόρμα.</li>
            <li><strong>Δεδομένα Χρήσης:</strong> πληροφορίες σχετικά με τον τρόπο χρήσης του ιστότοπου, των προϊόντων και των υπηρεσιών μας.</li>
            <li><strong>Δεδομένα Μάρκετινγκ και Επικοινωνίας:</strong> προτιμήσεις σας για λήψη μάρκετινγκ από εμάς.</li>
          </ul>
        </section>

        <section>
          <h2>3. Πώς Χρησιμοποιούμε τα Δεδομένα σας</h2>
          <p>Θα χρησιμοποιήσουμε τα προσωπικά σας δεδομένα μόνο όταν ο νόμος μας το επιτρέπει. Πιο συχνά, θα χρησιμοποιήσουμε τα προσωπικά σας δεδομένα στις ακόλουθες περιστάσεις:</p>
          <ul>
            <li>Για την παροχή και τη διατήρηση των υπηρεσιών μας.</li>
            <li>Για να σας ειδοποιήσουμε σχετικά με αλλαγές στις υπηρεσίες μας.</li>
            <li>Για να σας επιτρέψουμε να συμμετέχετε σε διαδραστικές λειτουργίες των υπηρεσιών μας.</li>
            <li>Για την παροχή υποστήριξης πελατών.</li>
            <li>Για τη συλλογή αναλύσεων ή πολύτιμων πληροφοριών ώστε να μπορέσουμε να βελτιώσουμε τις υπηρεσίες μας.</li>
            <li>Για την παρακολούθηση της χρήσης των υπηρεσιών μας.</li>
            <li>Για τον εντοπισμό, την πρόληψη και την αντιμετώπιση τεχνικών προβλημάτων.</li>
            <li>Για την αποστολή newsletters, υλικού μάρκετινγκ και άλλων πληροφοριών που μπορεί να σας ενδιαφέρουν.</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies και Τεχνολογίες Παρακολούθησης</h2>
          <p>
            Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες παρακολούθησης για την παρακολούθηση της δραστηριότητας 
            στον ιστότοπό μας και διατηρούμε ορισμένες πληροφορίες. Τα cookies είναι αρχεία με μικρή ποσότητα δεδομένων 
            που μπορεί να περιλαμβάνουν ένα ανώνυμο μοναδικό αναγνωριστικό.
          </p>
          <p>Χρησιμοποιούμε τα εξής είδη cookies:</p>
          <ul>
            <li><strong>Απαραίτητα Cookies:</strong> Αυτά τα cookies είναι απαραίτητα για τη λειτουργία του ιστότοπου.</li>
            <li><strong>Cookies Απόδοσης:</strong> Μας επιτρέπουν να αναγνωρίζουμε και να μετράμε τον αριθμό των επισκεπτών.</li>
            <li><strong>Cookies Λειτουργικότητας:</strong> Χρησιμοποιούνται για την αναγνώρισή σας όταν επιστρέφετε στον ιστότοπό μας.</li>
            <li><strong>Cookies Στόχευσης:</strong> Καταγράφουν την επίσκεψή σας στον ιστότοπό μας για σκοπούς μάρκετινγκ.</li>
          </ul>
        </section>

        <section>
          <h2>5. Google Analytics και Facebook Pixel</h2>
          <p>
            Χρησιμοποιούμε το Google Analytics για την ανάλυση της χρήσης του ιστότοπού μας και το Facebook Pixel 
            για την παρακολούθηση των μετατροπών από τις διαφημίσεις Facebook. Αυτά τα εργαλεία συλλέγουν πληροφορίες 
            ανώνυμα και αναφέρουν τις τάσεις του ιστότοπου χωρίς την αναγνώριση μεμονωμένων χρηστών.
          </p>
        </section>

        <section>
          <h2>6. Κοινοποίηση Δεδομένων</h2>
          <p>
            Μπορούμε να μοιραστούμε τα προσωπικά σας δεδομένα με τρίτους μόνο στις ακόλουθες περιπτώσεις:
          </p>
          <ul>
            <li>Με παρόχους υπηρεσιών που μας βοηθούν στη λειτουργία του ιστότοπού μας.</li>
            <li>Για συμμόρφωση με νομικές υποχρεώσεις.</li>
            <li>Για την προστασία και υπεράσπιση των δικαιωμάτων ή της περιουσίας μας.</li>
            <li>Με τη συγκατάθεσή σας για οποιονδήποτε άλλο σκοπό.</li>
          </ul>
        </section>

        <section>
          <h2>7. Ασφάλεια Δεδομένων</h2>
          <p>
            Έχουμε εφαρμόσει κατάλληλα μέτρα ασφαλείας για να αποτρέψουμε την απώλεια, την κατάχρηση ή την αλλοίωση 
            των προσωπικών σας δεδομένων. Περιορίζουμε την πρόσβαση στα προσωπικά σας δεδομένα σε εκείνους τους 
            υπαλλήλους, αντιπροσώπους, εργολάβους και άλλα τρίτα μέρη που έχουν επαγγελματική ανάγκη να γνωρίζουν.
          </p>
        </section>

        <section>
          <h2>8. Τα Δικαιώματά σας</h2>
          <p>Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), έχετε τα ακόλουθα δικαιώματα:</p>
          <ul>
            <li><strong>Δικαίωμα πρόσβασης:</strong> Μπορείτε να ζητήσετε αντίγραφα των προσωπικών σας δεδομένων.</li>
            <li><strong>Δικαίωμα διόρθωσης:</strong> Μπορείτε να ζητήσετε να διορθώσουμε πληροφορίες που πιστεύετε ότι είναι ανακριβείς.</li>
            <li><strong>Δικαίωμα διαγραφής:</strong> Μπορείτε να ζητήσετε να διαγράψουμε τα προσωπικά σας δεδομένα.</li>
            <li><strong>Δικαίωμα περιορισμού της επεξεργασίας:</strong> Μπορείτε να ζητήσετε να περιορίσουμε την επεξεργασία των προσωπικών σας δεδομένων.</li>
            <li><strong>Δικαίωμα εναντίωσης στην επεξεργασία:</strong> Μπορείτε να αντιταχθείτε στην επεξεργασία των προσωπικών σας δεδομένων.</li>
            <li><strong>Δικαίωμα φορητότητας δεδομένων:</strong> Μπορείτε να ζητήσετε τη μεταφορά των δεδομένων σε άλλο οργανισμό.</li>
          </ul>
        </section>

        <section>
          <h2>9. Διατήρηση Δεδομένων</h2>
          <p>
            Θα διατηρήσουμε τα προσωπικά σας δεδομένα μόνο για όσο διάστημα είναι απαραίτητο για τους σκοπούς που 
            ορίζονται σε αυτήν την πολιτική απορρήτου. Θα διατηρήσουμε και θα χρησιμοποιήσουμε τα προσωπικά σας 
            δεδομένα στον βαθμό που είναι απαραίτητο για τη συμμόρφωση με τις νομικές μας υποχρεώσεις.
          </p>
        </section>

        <section>
          <h2>10. Προστασία Ανηλίκων</h2>
          <p>
            Οι υπηρεσίες μας δεν απευθύνονται σε άτομα κάτω των 16 ετών. Δεν συλλέγουμε εν γνώσει μας προσωπικά 
            αναγνωρίσιμες πληροφορίες από άτομα κάτω των 16 ετών. Εάν είστε γονέας ή κηδεμόνας και γνωρίζετε ότι 
            το παιδί σας μας έχει παράσχει προσωπικά δεδομένα, επικοινωνήστε μαζί μας.
          </p>
        </section>

        <section>
          <h2>11. Αλλαγές στην Πολιτική Απορρήτου</h2>
          <p>
            Μπορούμε να ενημερώσουμε την πολιτική απορρήτου μας κατά καιρούς. Θα σας ειδοποιήσουμε για τυχόν αλλαγές 
            δημοσιεύοντας τη νέα πολιτική απορρήτου σε αυτήν τη σελίδα και ενημερώνοντας την ημερομηνία "Τελευταία ενημέρωση" 
            στην κορυφή αυτής της πολιτικής απορρήτου.
          </p>
        </section>

        <section>
          <h2>12. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτήν την πολιτική απορρήτου ή τις πρακτικές μας, 
            επικοινωνήστε μαζί μας:
          </p>
          <ul>
            <li>Email: <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a></li>
            <li>Ιστότοπος: https://ecunel.com</li>
          </ul>
        </section>

        <section>
          <h2>13. Συγκατάθεση</h2>
          <p>
            Χρησιμοποιώντας τον ιστότοπό μας, συγκατατίθεστε στην πολιτική απορρήτου μας και συμφωνείτε με τους όρους της.
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;